var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip-group',{attrs:{"active-class":"red white--text"},model:{value:(_vm.filterValue),callback:function ($$v) {_vm.filterValue=$$v},expression:"filterValue"}},[_c('v-chip',{attrs:{"filter":"","label":"","value":true}},[_vm._v(" محذوف ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }